

import React, { createContext, Dispatch } from "react";
import { storageMng } from "../helper/StorageMng";
import { AccountInfoModel } from "../generated/api";
import { jwtDecode } from "jwt-decode";
import { JwtPayload } from "../models/JwtPayload";

interface CurrUserContextType {
  setUserData: (item: AccountInfoModel | undefined) => void;
  getCurrUserData: () => AccountInfoModel | undefined;  
  getCurrUsrToken:() => string | undefined,
  isAuthorized: () => boolean;
}

const CurrUserContext = React.createContext<CurrUserContextType>({
  setUserData: () => { },
  getCurrUserData: () => undefined,
  getCurrUsrToken:() => undefined,
  isAuthorized: () => false,
});


export const setUserData = (usr: AccountInfoModel | undefined) => {
  storageMng.storUserProfile(usr);
  storageMng.storAccessToken(usr?.accessToken); // TODO : throw access token only
  if (usr) storageMng.storSessionActive();
  else storageMng.removeSessionActive();
};

export const getCurrUserData = (): AccountInfoModel | undefined => {
  return isAuthorized()? storageMng.getUserProfile():undefined;
};

export const getCurrUsrToken = (): string | undefined => {
  if (isAuthorized()) {
    const token = storageMng.getِAccessToken();
    const decoded = jwtDecode<JwtPayload>(token!);
    return decoded.nameid;
  }
  else
    return undefined;
};

export const isAuthorized = (): boolean => {
  const token = storageMng.getِAccessToken();
  return !isTokenExpired(token);
};

export const isTokenExpired = (token: string | undefined): boolean => {
  try {
    if (!token) return true;

    const decoded = jwtDecode<JwtPayload>(token);
    const now = Date.now() / 1000; // current time in seconds
    return decoded.exp < now;
  } catch {
    return true; // treat invalid tokens as expired
  }
}
export default CurrUserContext


